// extracted by css-extract-rspack-plugin
export default {"overlay":"YJ49G"};